import { render, staticRenderFns } from "./BlockedIcon.vue?vue&type=template&id=56f2b254"
import script from "./BlockedIcon.vue?vue&type=script&lang=js"
export * from "./BlockedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports